module.exports = __webpack_public_path__ + "slide13.22b6a15e5e09ff3823b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/private/home/slide13.jpg
// module id = ./src/assets/images/private/home/slide13.jpg
// module chunks = main